import { render, staticRenderFns } from "./serial-winning.vue?vue&type=template&id=51cd0a23&scoped=true"
import script from "./serial-winning.vue?vue&type=script&lang=js"
export * from "./serial-winning.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51cd0a23",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/Paldia/Paldia FE/FE-Paldia-Staging/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51cd0a23')) {
      api.createRecord('51cd0a23', component.options)
    } else {
      api.reload('51cd0a23', component.options)
    }
    module.hot.accept("./serial-winning.vue?vue&type=template&id=51cd0a23&scoped=true", function () {
      api.rerender('51cd0a23', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/phase2/manager-form/iframe-page/components/form-b/serial-winning.vue"
export default component.exports